export const mediumOptions = [
    {text: 'CD', value: 'CD'},
    {text: 'LP', value: 'LP'},
    {text: 'MC', value: 'MC'},
    {text: 'Other', value: 'Other'},
]